/**
 * @requires jquery.js
 * @requires ua-parser.js
 *
 * @author dan.west@chrometoaster.com
 *
 * @Utilitiy functions
 *
 */

var Utils = (function () {
    'use strict';

    // ----------------------
    // Define private methods
    // ----------------------

    var _applyUtils = function () {
        var $body = $('body');

        // Generate Util classes

        // Set the user agent if IE 10/11
            // IE10 Used as a result for not supporting CSS pointer events
            // IE11 used for styling select placeholders

        var doc = document.documentElement;
        if (navigator.userAgent.indexOf('MSIE 10.0') !== -1) {
            $body.addClass('ie10');
        }
        if (navigator.userAgent.indexOf('Trident') !== -1 && navigator.userAgent.indexOf('rv:11') !== -1) {
            $body.addClass('ie11');
        }
    };

    // ---------------------
    // Define public methods
    // ---------------------

    var init = function () {
        _applyUtils();
    };

    // --------------------------
    // Expose methods and objects
    // --------------------------

    return {
        init: init
    };
})();

$(document).ready(function() {
    Utils.init();
});